import { api } from '@ai/common/src/api/axios';

class WidgetService {
  private baseUrl = '/widget/api/v1';

  synthesize = async ({
    text,
    voice,
    emotion,
    speed,
    sampleRate,
  }: {
    text: string;
    voice: string;
    emotion?: string;
    speed: number;
    sampleRate: number;
  }) =>
    await api.post<Blob>(
      `${this.baseUrl}/tts`,
      { text, voice, emotion, speed, sample_rate: sampleRate },
      { responseType: 'blob' }
    );
}

export const widgetService = new WidgetService();
